module.exports = __webpack_public_path__ + "static/media/recommend-selected.3d9cef60.svg";